import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ConfigService } from '@shared/services/config.service';
import { Constant } from '@shared/utilities/constant';

@Injectable()
export class LandingResolver implements Resolve<any> {

  private brandingData: any;

  constructor(
    private configService: ConfigService,
    private http: HttpClient,
    @Inject('BRANDING_JSON_PATH') private brandingJsonPath: string
  ) {}

  resolve(): Promise<any> {
    let keys = Constant.Config.landingAvatar + "," + Constant.Config.landingVideo + "," + Constant.Config.landingVideoIcon + "," + Constant.Config.landingAvatarIcon + "," + Constant.Config.landingAvatarMobileIcon;
    return this.http.get(this.brandingJsonPath).toPromise().then((brandingData: any) => {
      this.brandingData = brandingData;
 
      return this.configService.GetConfigs(keys).then((response) => {
        console.log(response);
        let videoPath='',avatarPath='',videoIconPath='',avatarIconPath='',avatarMobileIconPath='';
        if (response) {
          let dictConfig = [];
          
          if (response) {
            Object.entries(response).forEach(itm => dictConfig.push({ key: itm[0], value: itm[1] }));
          }
          if (dictConfig) {
            videoPath = (dictConfig.filter(x => x.key == Constant.Config.landingVideo)[0]).value as string;
            avatarPath = (dictConfig.filter(x => x.key == Constant.Config.landingAvatar)[0]).value as string;
            videoIconPath = (dictConfig.filter(x => x.key == Constant.Config.landingVideoIcon)[0]).value as string;
            avatarIconPath = (dictConfig.filter(x => x.key == Constant.Config.landingAvatarIcon)[0]).value as string;
            avatarMobileIconPath = (dictConfig.filter(x => x.key == Constant.Config.landingAvatarMobileIcon)[0]).value as string;
          }

        }

        const clientId = sessionStorage.getItem(Constant.ClientId);
        const brandKey = clientId.toUpperCase();
      

        const mainImage = brandKey && this.brandingData[brandKey]?.landing_desktop_background || '';
        const chatBackgroundImage = brandKey && this.brandingData[brandKey]?.chat_background_image || '';
        const logoUrl = brandKey && this.brandingData[brandKey]?.branding_product_landing || '';
        const landingMobileImage=brandKey && this.brandingData[brandKey]?.branding_product_landing_mobile || '';

        return [videoPath,avatarPath,videoIconPath,avatarIconPath,avatarMobileIconPath,mainImage, chatBackgroundImage, logoUrl,landingMobileImage];
      })
      .catch(error => {
        // Handle errors here
        console.error('Error fetching data', error);
       
        return Promise.resolve(null); // or throw error
      });
    });
  }
}
